// extracted by mini-css-extract-plugin
export default {"wrapperHomeCategoriesRow":"HomeCategories_wrapperHomeCategoriesRow__WTz+0","marginB":"HomeCategories_marginB__nWrzI","marginR":"HomeCategories_marginR__pGOX7"};